import { createSlice } from "@reduxjs/toolkit";

export const DataSlice = createSlice({
  name: "Data",
  initialState: {
    val: 0,
    val1: 0,
  },
  reducers: {
    studyValue: (state, action) => {
      state.val = action.payload;
    },
    menuValue: (state, action) => {
      state.val1 = action.payload;
    },
  },
});

export const { studyValue, menuValue } = DataSlice.actions;

export default DataSlice.reducer;
